export class OptimizationGroupMembership {
	public index;
	
	constructor(obj) {
		this.index = obj.index;
	}
} 
